import React from "react";

interface DotPatternProps {
  className?: string;
}

const DotPattern: React.FC<DotPatternProps> = ({ className = "" }) => (
  <div
    className={className}
    style={{
      backgroundImage:
        "radial-gradient(circle, #9ca3af 1.25px, transparent 1.5px)",
      backgroundSize: "14px 14px",
      opacity: 0.18,
    }}
  />
);

export default DotPattern;
